/**
 * Format file size in a human readable format
 * @param {number} size File size
 * @returns {string} Formatted size
 */
export default function (size) {
  if (typeof size !== 'number' || isNaN(size)) {
    throw new TypeError('Expected a number')
  }

  const isNegative = size < 0

  if (isNegative) {
    size = -size
  }

  if (size < 1) {
    return (isNegative ? '-' : '') + size + ' B'
  }

  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const exponent = Math.min(Math.floor(Math.log(size) / Math.log(1000)), units.length - 1)
  const unit = units[exponent]

  size = (size / Math.pow(1000, exponent)).toFixed(2) * 1

  return (isNegative ? '-' : '') + size + ' ' + unit
}
